import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Container } from 'react-bootstrap'
import emailjs from '@emailjs/browser'
import './HomeFormulario.css'

const serviceId =
  process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_2s8vdwe'
const templateId =
  process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_6owny6s'
const publicKey =
  process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '197ygxSEGrRTw4UCW'

const USER_FORM_ORIGIN = 'Newsletter'

const HomeFormulario = () => {
  const [buttonSend, setButtonSend] = useState(true)
  const [formSent, setFormSent] = useState(false)
  const [sendError, setSendError] = useState(false)
  const [formSending, setFormSending] = useState(false)

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      userName: '',
      userForm: USER_FORM_ORIGIN,
      userTelephone: '',
      userEmail: '',
      userMessage: '',
    },
  })

  function sendEmail(_data, e) {
    e.preventDefault()
    setSendError(false)
    setButtonSend(false)
    setFormSending(true)

    emailjs
      .sendForm(serviceId, templateId, e.target, publicKey)
      .then(() => {
        reset({
          userName: '',
          userForm: USER_FORM_ORIGIN,
          userTelephone: '',
          userEmail: '',
          userMessage: '',
        })
        setFormSent(true)
        setFormSending(false)
        setTimeout(() => {
          setFormSent(false)
          setButtonSend(true)
        }, 7000)
      })
      .catch(() => {
        setSendError(true)
        setFormSending(false)
        setButtonSend(true)
      })
  }

  return (
    <article>
      <Container className="contactoHomeContainer">
        <p className="contactoHomeContainer__text">
          Dejanos tu consulta o suscribite a nuestro newsletter
        </p>

        <form
          className="row d-flex justify-content-center"
          onSubmit={handleSubmit(sendEmail)}
        >
          <input type="hidden" {...register('userForm')} />
          <div className="col-md-5 formInputsBlock">
            <input
              type="text"
              {...register('userName', {
                required: 'Ingresá tu nombre.',
                minLength: {
                  value: 3,
                  message: 'El nombre debe tener al menos 3 caracteres.',
                },
              })}
              placeholder="Nombre *"
              className="formInput__box"
              autoComplete="name"
            />
            <p className="formInput__error">{errors.userName?.message}</p>

            <input
              type="tel"
              {...register('userTelephone', {
                required: 'Ingresá un número de teléfono.',
                minLength: {
                  value: 8,
                  message: 'El teléfono debe tener al menos 8 dígitos.',
                },
              })}
              placeholder="Teléfono *"
              className="formInput__box"
              autoComplete="tel"
            />
            <p className="formInput__error">{errors.userTelephone?.message}</p>

            <input
              type="email"
              {...register('userEmail', {
                required: 'Ingresá tu correo electrónico.',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'El formato del correo no es válido.',
                },
              })}
              placeholder="Email *"
              className="formInput__box"
              autoComplete="email"
            />
            <p className="formInput__error">{errors.userEmail?.message}</p>
          </div>
          <div className="col-md-5">
            <textarea
              {...register('userMessage', {
                required: 'Escribí tu consulta.',
                minLength: {
                  value: 15,
                  message: 'La consulta debe tener al menos 15 caracteres.',
                },
              })}
              placeholder="Deja tu mensaje o Quiero suscribirme *"
              className="formInput__box formInput__textarea"
              rows={5}
            />
            <p className="formInput__error">{errors.userMessage?.message}</p>
          </div>

          {formSending && (
            <div className="col-md-10 text-center">
              <p className="contacto__status contacto__status--sending">
                Enviando…
              </p>
            </div>
          )}
          <div className="col-md-10 text-center pb-0 mb-3">
            {formSent && (
              <p className="formInput__sent contacto__alert-msg">
                Mensaje enviado correctamente. Te responderemos a la brevedad.
                <br />
                Muchas gracias.
              </p>
            )}
            {sendError && (
              <p className="formInput__sentNo contacto__alert-msg">
                No se pudo enviar el mensaje. Verificá tu conexión o intentá de
                nuevo en unos minutos.
              </p>
            )}
            {buttonSend && (
              <button
                type="submit"
                className="button-rounded--outline"
                disabled={formSending}
              >
                Enviar
              </button>
            )}
          </div>
        </form>
      </Container>
    </article>
  )
}

export default HomeFormulario
